import { render, staticRenderFns } from "./CoSyncFileConflictNotification.vue?vue&type=template&id=4a808b39&scoped=true&"
import script from "./CoSyncFileConflictNotification.vue?vue&type=script&lang=ts&"
export * from "./CoSyncFileConflictNotification.vue?vue&type=script&lang=ts&"
import style0 from "./CoSyncFileConflictNotification.vue?vue&type=style&index=0&id=4a808b39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a808b39",
  null
  
)

export default component.exports